// import React from 'react'
// import './ArticleMeta.scss'

const ArticleMetaDivider = () => {
  return null
}

export default ArticleMetaDivider
